import { omit } from '@/utils';

export interface Country {
  chineseName: string;
  englishName: string;
  twoLetterCode: string;
}

// 国家 ISO表
const Country: Record<string, string> = {
  AF: 'Afghanistan	阿富汗',
  AL: 'Albania	阿尔巴尼亚',
  DZ: 'Algeria	阿尔及利亚',
  AD: 'Andorra	安道尔',
  AO: 'Angola	安哥拉',
  AI: 'Anguilla	安圭拉',
  AG: 'Antigua and Barbuda	安提瓜和巴布达岛',
  AE: 'Arab Emirates	阿联酋',
  AR: 'Argentina	阿根廷',
  AM: 'Armenia	亚美尼亚',
  AW: 'Aruba	阿鲁巴',
  AU: 'Australia	澳大利亚',
  AT: 'Austria	奥地利',
  AZ: 'Azerbaijan	阿塞拜疆',
  BS: 'Bahamas 巴哈马',
  BH: 'Bahrain	巴林',
  BD: 'Bangladesh	孟加拉国',
  BB: 'Barbados	巴巴多斯',
  BY: 'Belarus	白俄罗斯',
  BE: 'Belgium	比利时',
  BZ: 'Belize	伯利兹',
  BJ: 'Benin	贝宁',
  BM: 'Bermuda	百慕大群岛',
  BT: 'Bhutan	不丹',
  BO: 'Bolivia	玻利维亚',
  BQ: 'Bonaire	博内尔岛',
  BIH: 'Bosnia 	波斯尼亚',
  BW: 'Botswana	博茨瓦纳',
  BV: 'Bouvet Island	布维岛',
  BR: 'Brazil	巴西',
  BN: 'Brunei	文莱',
  BG: 'Bulgaria	保加利亚',
  BF: 'Burkina Faso	布基纳法索',
  BI: 'Burundi	布隆迪',
  KH: 'Cambodia	柬埔寨',
  CM: 'Cameroon	喀麦隆',
  CA: 'Canada	加拿大',
  CV: 'Cape Verde	佛得角',
  KY: 'Cayman Islands	开曼群岛',
  CF: 'Central African Republic	中非',
  TD: 'Chad	乍得',
  CL: 'Chile	智利',
  HK: 'Hong Kong SAR China	中国香港',
  CN: 'China	中国',
  CC: 'Cocos Islands	科科斯群岛',
  CO: 'Colombia	哥伦比亚',
  KM: 'Comoros	科摩罗',
  CG: 'Congo	刚果',
  CD: 'Congo, Democratic Republic of the Congo	刚果民主共和国',
  CK: 'Cook Islands	库克群岛',
  CR: 'Costa Rica	哥斯达黎加',
  HR: 'Croatia	克罗地亚',
  CU: 'Cuba	古巴',
  CW: 'Curacao	库拉索岛',
  CY: 'Cyprus	塞浦路斯',
  CZ: 'Czech Republic	捷克',
  CS: 'Czechoslovakia	捷克斯洛伐克',
  DK: 'Denmark	丹麦',
  DJ: 'Djibouti	吉布提',
  DM: 'Dominica	多米尼加',
  DO: 'Dominican Republic	多明尼加共和国',
  EC: 'Ecuador	厄瓜多尔',
  EG: 'Egypt	埃及',
  SV: 'El Salvador	萨尔瓦多',
  GQ: 'Equatorial Guinea	赤道几内亚',
  ER: 'Eritrea	厄立特里亚',
  EE: 'Estonia	爱沙尼亚',
  ET: 'Ethiopia	埃塞俄比亚',
  FK: 'Falkland Islands	福克兰群岛',
  FO: 'Faroe Islands	法罗群岛',
  FJ: 'Fiji	斐济',
  FI: 'Finland	芬兰',
  FR: 'France	法国',
  GF: 'French Guiana	法属圭亚那',
  PF: 'French Polynesia	法属波利尼西亚',
  GA: 'Gabon	加蓬',
  GM: 'Gambia	冈比亚',
  GE: 'Georgia, Republic of Georgia	格鲁吉亚共和国',
  DE: 'Germany	德国',
  GH: 'Ghana	加纳',
  GI: 'Gibraltar	直布罗陀',
  GR: 'Greece	希腊',
  GL: 'Greenland	格陵兰岛',
  GD: 'Grenada	格林纳达',
  GP: 'Guadeloupe	瓜德罗普岛',
  GT: 'Guatemala	危地马拉',
  GG: 'Guernsey	根西岛',
  GN: 'Guinea	几内亚',
  GW: 'Guinea-Bissau	几内亚比绍',
  GY: 'Guyana	圭亚那',
  HT: 'Haiti	海地',
  HN: 'Honduras	洪都拉斯',
  HU: 'Hungary	匈牙利',
  IS: 'Iceland	冰岛',
  IN: 'India	印度',
  ID: 'Indonesia	印度尼西亚',
  IR: 'Iran	伊朗',
  IQ: 'Iraq	伊拉克',
  IE: 'Ireland	爱尔兰',
  IM: 'Isle of Man	马恩岛',
  IL: 'Israel	以色列',
  IT: 'Italy	意大利',
  CI: 'Ivory Coast	象牙海岸',
  JM: 'Jamaica	牙买加',
  JP: 'Japan	日本',
  JE: 'Jersey	泽西',
  JO: 'Jordan	约旦',
  KZ: 'Kazakhstan	哈萨克斯坦',
  KE: 'Kenya	肯尼亚',
  KI: 'Kiribati	基里巴斯',
  KW: 'Kuwait	科威特',
  KG: 'Kyrgyzstan	吉尔吉斯斯坦',
  LA: 'Laos	老挝',
  LV: 'Latvia	拉脱维亚',
  LB: 'Lebanon	黎巴嫩',
  LS: 'Lesotho	莱索托',
  LR: 'Liberia	利比里亚',
  LY: 'Libya	利比亚',
  LI: 'Liechtenstein	列支敦士登',
  LT: 'Lithuania	立陶宛',
  LU: 'Luxembourg	卢森堡',
  MO: 'Macao SAR China	澳门',
  MK: 'Macedonia 	马其顿',
  MG: 'Madagascar	马达加斯加',
  MW: 'Malawi	马拉维',
  MY: 'Malaysia	马来西亚',
  MV: 'Maldives	马尔代夫',
  ML: 'Mali	马里',
  MT: 'Malta	马耳他',
  MH: 'Marshall Islands	马绍尔群岛',
  MQ: 'Martinique	马提尼克',
  MR: 'Mauritania	毛里塔尼亚',
  MU: 'Mauritius	毛里求斯',
  MX: 'Mexico	墨西哥',
  MD: 'Moldova	摩尔多瓦',
  MC: 'Monaco	摩纳哥',
  MN: 'Mongolia	蒙古',
  ME: 'Montenegro	黑山',
  MS: 'Montserrat	蒙特塞拉特岛',
  MA: 'Morocco	摩洛哥',
  MZ: 'Mozambique	莫桑比克',
  MM: 'Myanmar	缅甸',
  NA: 'Namibia	纳米比亚',
  NR: 'Nauru	瑙鲁',
  NP: 'Nepal	尼泊尔',
  NL: 'Netherlands	荷兰',
  AN: 'Netherlands Antilles	荷属安的列斯群岛',
  NC: 'New Caledonia	新喀里多尼亚',
  PG: 'New Guinea	新几内亚',
  NZ: 'New Zealand	新西兰',
  NI: 'Nicaragua	尼加拉瓜',
  NE: 'Niger	尼日尔',
  NG: 'Nigeria	尼日利亚',
  NF: 'Norfolk Island	诺福克岛',
  KP: 'North Korea	朝鲜',
  MP: 'Northern Mariana Islands	北马里亚纳群岛',
  NO: 'Norway	挪威',
  OM: 'Oman	阿曼',
  PK: 'Pakistan	巴基斯坦',
  PW: 'Palau	帕劳',
  PA: 'Panama	巴拿马',
  PNG: 'Papua New Guinea	巴布亚新几内亚',
  PY: 'Paraguay	巴拉圭',
  PE: 'Peru	秘鲁',
  PH: 'Philippines	菲律宾',
  PL: 'Poland	波兰',
  PT: 'Portugal	葡萄牙',
  QA: 'Qatar	卡塔尔',
  RH: 'Rhodesia	罗得西亚',
  RO: 'Romania	罗马尼亚',
  RU: 'Russian Federation	 俄罗斯',
  RW: 'Rwanda	卢旺达',
  SH: 'Saint Helena, Ascension and Tristan da Cunha	圣赫勒拿、阿森松和特里斯坦-达库尼亚',
  KN: 'Saint Kitts and Nevis	圣基茨和尼维斯',
  WS: 'Samoa	萨摩亚',
  SM: 'San Marino	圣马力诺',
  ST: 'Sao Tome and Principe	圣多美和普林西比',
  SA: 'Saudi Arabia	沙特阿拉伯',
  SN: 'Senegal	塞内加尔',
  RS: 'Serbia	塞尔维亚',
  SC: 'Seychelles	塞舌尔',
  SL: 'Sierra Leone	塞拉利昂',
  SG: 'Singapore	新加坡',
  SX: 'Sint Maarten Sint Maarten 荷属圣马丁',
  SK: 'Slovakia	斯洛伐克',
  SI: 'Slovenia	斯洛文尼亚',
  SB: 'Solomon Islands	所罗门群岛',
  SO: 'Somalia	索马里',
  ZA: 'South Africa	南非',
  GS: 'South Georgia and the South Sandwich Islands	南乔治亚岛和南威奇群岛',
  KR: 'South Korea	韩国',
  ES: 'Spain	西班牙',
  LK: 'Sri Lanka	斯里兰卡',
  LC: 'St. Lucia	圣露西亚',
  VC: 'St. Vincent and the Grenadines	圣文森特和格林纳丁斯',
  SD: 'Sudan	苏丹',
  SR: 'Suriname	苏里南',
  SZ: 'Swaziland	斯威士兰',
  SE: 'Sweden	瑞典',
  CH: 'Switzerland	瑞士',
  SY: 'Syria	叙利亚',
  TW: 'Taiwan(China)	中国台湾',
  TJ: 'Tajikistan	塔吉克斯坦',
  TZ: 'Tanzania	坦桑尼亚',
  TH: 'Thailand	泰国',
  TL: 'Timor-Leste	东帝汶',
  TG: 'Togo	多哥',
  TO: 'Tonga	汤加',
  TT: 'Trinidad and Tobago	特立尼达和多巴哥',
  TN: 'Tunisia	突尼斯',
  TR: 'Turkey	土耳其',
  TM: 'Turkmenistan	土库曼斯坦',
  TC: 'Turks and Caicos Islands	土耳其和凯科斯群岛',
  TV: 'Tuvalu	图瓦卢',
  UG: 'Uganda	乌干达',
  UA: 'Ukraine	乌克兰',
  GB: 'United Kingdom	英国',
  US: 'United States of America	美国',
  UY: 'Uruguay	乌拉圭',
  UZ: 'Uzbekistan	乌兹别克斯坦',
  VU: 'Vanuatu 	瓦努阿图',
  VA: 'Vatican	梵蒂冈',
  VE: 'Venezuela	委内瑞拉',
  VN: 'Viet Nam	越南',
  VG: 'Virgin (British) Islands	英属群岛',
  EH: 'Western Sahara	西撒哈拉',
  YE: 'Yemen	也门',
  YU: 'Yugoslavia	南斯拉夫',
  ZM: 'Zambia	赞比亚',
  ZW: 'Zimbabwe	津巴布韦',
  Others: 'Others 其他',
};

const CountryDeleted: Record<string, string> = {
  AF: 'Afghanistan 阿富汗',
  BQ: 'Bonaire, Saint Eustatius, and Saba 博内尔岛，Saint Eustatius, Saa',
  BIH: 'Bosnia and Herzegovina Bosnia和Herzegovina',
  BV: 'Bouvet Island 布维岛',
  CF: 'Central African Republic 中非共和国',
  CC: 'Cocos Islands 科科斯群岛',
  CG: 'Congo 刚果',
  CD: 'Congo, Democratic Republic of the Congo 刚果民主共和国',
  CS: 'Czechoslovakia 捷克斯洛伐克',
  FK: 'Falkland Islands (Malvinas) 福克兰群岛（Malvinas）',
  GF: 'French Guiana 法属圭亚那',
  DD: 'German Democratic Republic 德意志民主共和国',
  GG: 'Guernsey 根西岛',
  GY: 'Guyana 圭亚那',
  IM: 'Isle of Man 马恩岛',
  JE: 'Jersey 泽西',
  AN: 'Netherlands Antilles 荷属安的列斯群岛',
  NF: 'Norfolk Island 诺福克岛',
  PNG: 'Papua New Guinea 巴布亚新几内亚',
  RH: 'Rhodesia 罗得西亚',
  GS: 'South Georgia and the South Sandwich Islands 南乔治亚岛和南威奇群岛',
  SR: 'Suriname 苏里南',
  SU: 'USSR 苏联',
  YU: 'Yugoslavia 南斯拉夫',
};

export const fullCountry = omit(Country, Object.keys(CountryDeleted));

interface Area {
  areaName: string;
  areaEnglishName: string;
  areaKey: number;
  countryList: Country[];
}

export interface Country {
  countryId: number;
  chineseName: string;
  englishName: string;
  twoLetterCode: string;
  phoneCode?: string;
}

export const areaCountryList: Area[] = [
  {
    areaName: '东南亚',
    areaEnglishName: 'Southeast Asia',
    areaKey: 0,
    countryList: [
      {
        countryId: 106,
        chineseName: '菲律宾',
        englishName: 'Philippines',
        twoLetterCode: 'PH',
        phoneCode: '+63',
      },
      {
        countryId: 102,
        chineseName: '马来西亚',
        englishName: 'Malaysia',
        twoLetterCode: 'MY',
        phoneCode: '+60',
      },
      {
        countryId: 108,
        chineseName: '泰国',
        englishName: 'Thailand',
        twoLetterCode: 'TH',
        phoneCode: '+66',
      },
      {
        countryId: 110,
        chineseName: '新加坡',
        englishName: 'Singapore',
        twoLetterCode: 'SG',
        phoneCode: '+65',
      },
      {
        countryId: 100,
        chineseName: '印度尼西亚',
        englishName: 'Indonesia',
        twoLetterCode: 'ID',
        phoneCode: '+62',
      },
      {
        countryId: 104,
        chineseName: '越南',
        englishName: 'Vietnam',
        twoLetterCode: 'VN',
        phoneCode: '+84',
      },
      {
        countryId: 120,
        chineseName: '东帝汶',
        englishName: 'Timor-Leste',
        twoLetterCode: 'TL',
        phoneCode: '+670',
      },
      {
        countryId: 114,
        chineseName: '柬埔寨',
        englishName: 'Cambodia',
        twoLetterCode: 'KH',
        phoneCode: '+855',
      },
      {
        countryId: 112,
        chineseName: '老挝',
        englishName: 'Laos',
        twoLetterCode: 'LA',
        phoneCode: '+856',
      },
      {
        countryId: 116,
        chineseName: '缅甸',
        englishName: 'Myanmar (Burma)',
        twoLetterCode: 'MM',
        phoneCode: '+95',
      },
      {
        countryId: 118,
        chineseName: '文莱',
        englishName: 'Brunei',
        twoLetterCode: 'BN',
        phoneCode: '+673',
      },
    ],
  },
  {
    areaName: '澳洲',
    areaEnglishName: 'Australia',
    areaKey: 1,
    countryList: [
      {
        countryId: 502,
        chineseName: '澳大利亚',
        englishName: 'Australia',
        twoLetterCode: 'AU',
        phoneCode: '+61',
      },
      {
        countryId: 504,
        chineseName: '新西兰',
        englishName: 'New Zealand',
        twoLetterCode: 'NZ',
        phoneCode: '+64',
      },
      {
        countryId: 520,
        chineseName: '巴布亚新几内亚',
        englishName: 'Papua New Guinea',
        twoLetterCode: 'PG',
        phoneCode: '+675',
      },
      {
        countryId: 516,
        chineseName: '北马里亚纳',
        englishName: 'Northern Mariana Islands',
        twoLetterCode: 'MP',
        phoneCode: '+1',
      },
      {
        countryId: 542,
        chineseName: '法属波利尼西亚',
        englishName: 'French Polynesia',
        twoLetterCode: 'PF',
        phoneCode: '+689',
      },
      {
        countryId: 526,
        chineseName: '斐济',
        englishName: 'Fiji',
        twoLetterCode: 'FJ',
        phoneCode: '+679',
      },
      {
        countryId: 518,
        chineseName: '关岛',
        englishName: 'Guam',
        twoLetterCode: 'GU',
        phoneCode: '+1671',
      },
      {
        countryId: 512,
        chineseName: '基里巴斯',
        englishName: 'Kiribati',
        twoLetterCode: 'KI',
        phoneCode: '+686',
      },
      {
        countryId: 536,
        chineseName: '库克群岛',
        englishName: 'Cook Islands',
        twoLetterCode: 'CK',
        phoneCode: '+682',
      },
      {
        countryId: 510,
        chineseName: '马绍尔群岛',
        englishName: 'Marshall Islands',
        twoLetterCode: 'MH',
        phoneCode: '+692',
      },
      {
        countryId: 548,
        chineseName: '美属萨摩亚',
        englishName: 'American Samoa',
        twoLetterCode: 'AS',
        phoneCode: '+684',
      },
      {
        countryId: 508,
        chineseName: '密克罗尼西亚联邦',
        englishName: 'Micronesia',
        twoLetterCode: 'FM',
      },
      {
        countryId: 514,
        chineseName: '瑙鲁',
        englishName: 'Nauru',
        twoLetterCode: 'NR',
        phoneCode: '+674',
      },
      {
        countryId: 538,
        chineseName: '纽埃',
        englishName: 'Niue',
        twoLetterCode: 'NU',
        phoneCode: '+683',
      },
      {
        countryId: 506,
        chineseName: '帕劳',
        englishName: 'Palau',
        twoLetterCode: 'PW',
        phoneCode: '+680',
      },
      {
        countryId: 546,
        chineseName: '皮特凯恩',
        englishName: 'Pitcairn Islands',
        twoLetterCode: 'PN',
      },
      {
        countryId: 532,
        chineseName: '萨摩亚',
        englishName: 'Samoa',
        twoLetterCode: 'WS',
        phoneCode: '+685',
      },
      {
        countryId: 522,
        chineseName: '所罗门群岛',
        englishName: 'Solomon Islands',
        twoLetterCode: 'SB',
        phoneCode: '+677',
      },
      {
        countryId: 534,
        chineseName: '汤加',
        englishName: 'Tonga',
        twoLetterCode: 'TO',
        phoneCode: '+676',
      },
      {
        countryId: 530,
        chineseName: '图瓦卢',
        englishName: 'Tuvalu',
        twoLetterCode: 'TV',
        phoneCode: '+688',
      },
      {
        countryId: 540,
        chineseName: '托克劳',
        englishName: 'Tokelau',
        twoLetterCode: 'TK',
        phoneCode: '+690',
      },
      {
        countryId: 544,
        chineseName: '瓦利斯和富图纳',
        englishName: 'Wallis & Futuna',
        twoLetterCode: 'WF',
        phoneCode: '+681',
      },
      {
        countryId: 524,
        chineseName: '瓦努阿图',
        englishName: 'Vanuatu',
        twoLetterCode: 'VU',
        phoneCode: '+678',
      },
      {
        countryId: 528,
        chineseName: '新喀里多尼亚',
        englishName: 'New Caledonia',
        twoLetterCode: 'NC',
        phoneCode: '+687',
      },
    ],
  },
  {
    areaName: '独联体',
    areaEnglishName: 'Commonwealth of Independent States',
    areaKey: 2,
    countryList: [
      {
        countryId: 152,
        chineseName: '俄罗斯',
        englishName: 'Russia',
        twoLetterCode: 'RU',
        phoneCode: '+7',
      },
      {
        countryId: 154,
        chineseName: '乌克兰',
        englishName: 'Ukraine',
        twoLetterCode: 'UA',
        phoneCode: '+380',
      },
      {
        countryId: 156,
        chineseName: '白俄罗斯',
        englishName: 'Belarus',
        twoLetterCode: 'BY',
        phoneCode: '+375',
      },
      {
        countryId: 162,
        chineseName: '哈萨克斯坦',
        englishName: 'Kazakhstan',
        twoLetterCode: 'KZ',
        phoneCode: '+73',
      },
      {
        countryId: 164,
        chineseName: '吉尔吉斯斯坦',
        englishName: 'Kyrgyzstan',
        twoLetterCode: 'KG',
        phoneCode: '+996',
      },
      {
        countryId: 158,
        chineseName: '摩尔多瓦',
        englishName: 'Moldova',
        twoLetterCode: 'MD',
        phoneCode: '+373',
      },
      {
        countryId: 160,
        chineseName: '塔吉克斯坦',
        englishName: 'Tajikistan',
        twoLetterCode: 'TJ',
        phoneCode: '+992',
      },
      {
        countryId: 168,
        chineseName: '土库曼斯坦',
        englishName: 'Turkmenistan',
        twoLetterCode: 'TM',
        phoneCode: '+993',
      },
      {
        countryId: 166,
        chineseName: '乌兹别克斯坦',
        englishName: 'Uzbekistan',
        twoLetterCode: 'UZ',
        phoneCode: '+998',
      },
    ],
  },
  {
    areaName: '欧洲',
    areaEnglishName: 'Europe',
    areaKey: 3,
    countryList: [
      {
        countryId: 446,
        chineseName: '爱尔兰',
        englishName: 'Ireland',
        twoLetterCode: 'IE',
        phoneCode: '+353',
      },
      {
        countryId: 424,
        chineseName: '奥地利',
        englishName: 'Austria',
        twoLetterCode: 'AT',
        phoneCode: '+43',
      },
      {
        countryId: 460,
        chineseName: '比利时',
        englishName: 'Belgium',
        twoLetterCode: 'BE',
        phoneCode: '+32',
      },
      {
        countryId: 442,
        chineseName: '冰岛',
        englishName: 'Iceland',
        twoLetterCode: 'IS',
        phoneCode: '+354',
      },
      {
        countryId: 438,
        chineseName: '丹麦',
        englishName: 'Denmark',
        twoLetterCode: 'DK',
        phoneCode: '+45',
      },
      {
        countryId: 422,
        chineseName: '德国',
        englishName: 'Germany',
        twoLetterCode: 'DE',
        phoneCode: '+49',
      },
      {
        countryId: 418,
        chineseName: '法国',
        englishName: 'France',
        twoLetterCode: 'FR',
        phoneCode: '+33',
      },
      {
        countryId: 440,
        chineseName: '芬兰',
        englishName: 'Finland',
        twoLetterCode: 'FI',
        phoneCode: '+358',
      },
      {
        countryId: 448,
        chineseName: '荷兰',
        englishName: 'Netherlands',
        twoLetterCode: 'NL',
        phoneCode: '+31',
      },
      {
        countryId: 436,
        chineseName: '挪威',
        englishName: 'Norway',
        twoLetterCode: 'NO',
        phoneCode: '+47',
      },
      {
        countryId: 428,
        chineseName: '葡萄牙',
        englishName: 'Portugal',
        twoLetterCode: 'PT',
        phoneCode: '+351',
      },
      {
        countryId: 434,
        chineseName: '瑞典',
        englishName: 'Sweden',
        twoLetterCode: 'SE',
        phoneCode: '+46',
      },
      {
        countryId: 444,
        chineseName: '瑞士',
        englishName: 'Switzerland',
        twoLetterCode: 'CH',
        phoneCode: '+41',
      },
      {
        countryId: 426,
        chineseName: '西班牙',
        englishName: 'Spain',
        twoLetterCode: 'ES',
        phoneCode: '+34',
      },
      {
        countryId: 432,
        chineseName: '希腊',
        englishName: 'Greece',
        twoLetterCode: 'GR',
        phoneCode: '+30',
      },
      {
        countryId: 430,
        chineseName: '意大利',
        englishName: 'Italy',
        twoLetterCode: 'IT',
        phoneCode: '+39',
      },
      {
        countryId: 420,
        chineseName: '英国',
        englishName: 'United Kingdom',
        twoLetterCode: 'GB',
        phoneCode: '+44',
      },
      {
        countryId: 474,
        chineseName: '阿尔巴尼亚',
        englishName: 'Albania',
        twoLetterCode: 'AL',
        phoneCode: '+355',
      },
      {
        countryId: 490,
        chineseName: '爱沙尼亚',
        englishName: 'Estonia',
        twoLetterCode: 'EE',
        phoneCode: '+372',
      },
      {
        countryId: 486,
        chineseName: '安道尔',
        englishName: 'Andorra',
        twoLetterCode: 'AD',
        phoneCode: '+376',
      },
      {
        countryId: 468,
        chineseName: '保加利亚',
        englishName: 'Bulgaria',
        twoLetterCode: 'BG',
        phoneCode: '+359',
      },
      {
        countryId: 500,
        chineseName: '波黑',
        englishName: 'Bosnia & Herzegovina',
        twoLetterCode: 'BA',
        phoneCode: '+387',
      },
      {
        countryId: 450,
        chineseName: '波兰',
        englishName: 'Poland',
        twoLetterCode: 'PL',
        phoneCode: '+48',
      },
      {
        countryId: 496,
        chineseName: '法罗群岛',
        englishName: 'Faroe Islands',
        twoLetterCode: 'FO',
        phoneCode: '+298',
      },
      {
        countryId: 484,
        chineseName: '梵蒂冈',
        englishName: 'Vatican City',
        twoLetterCode: 'VA',
        phoneCode: '+379',
      },
      {
        countryId: 556,
        chineseName: '根西岛',
        englishName: 'Guernsey',
        twoLetterCode: 'GG',
        phoneCode: '+1481',
      },
      {
        countryId: 480,
        chineseName: '黑山',
        englishName: 'Montenegro',
        twoLetterCode: 'ME',
        phoneCode: '+382',
      },
      {
        countryId: 452,
        chineseName: '捷克',
        englishName: 'Czechia',
        twoLetterCode: 'CZ',
        phoneCode: '+420',
      },
      {
        countryId: 478,
        chineseName: '克罗地亚',
        englishName: 'Croatia',
        twoLetterCode: 'HR',
        phoneCode: '+385',
      },
      {
        countryId: 492,
        chineseName: '拉脱维亚',
        englishName: 'Latvia',
        twoLetterCode: 'LV',
        phoneCode: '+371',
      },
      {
        countryId: 494,
        chineseName: '立陶宛',
        englishName: 'Lithuania',
        twoLetterCode: 'LT',
        phoneCode: '+370',
      },
      {
        countryId: 458,
        chineseName: '列支敦士登',
        englishName: 'Liechtenstein',
        twoLetterCode: 'LI',
        phoneCode: '+423',
      },
      {
        countryId: 462,
        chineseName: '卢森堡',
        englishName: 'Luxembourg',
        twoLetterCode: 'LU',
        phoneCode: '+352',
      },
      {
        countryId: 466,
        chineseName: '罗马尼亚',
        englishName: 'Romania',
        twoLetterCode: 'RO',
        phoneCode: '+40',
      },
      {
        countryId: 554,
        chineseName: '马恩岛',
        englishName: 'Isle of man',
        twoLetterCode: 'IM',
      },
      {
        countryId: 482,
        chineseName: '马耳他',
        englishName: 'Malta',
        twoLetterCode: 'MT',
        phoneCode: '+356',
      },
      {
        countryId: 550,
        chineseName: '马约特',
        englishName: 'Mayotte',
        twoLetterCode: 'YT',
        phoneCode: '+269',
      },
      {
        countryId: 464,
        chineseName: '摩纳哥',
        englishName: 'Monaco',
        twoLetterCode: 'MC',
        phoneCode: '+377',
      },
      {
        countryId: 472,
        chineseName: '前南马其顿',
        englishName: 'North Macedonia',
        twoLetterCode: 'MK',
        phoneCode: '+389',
      },
      {
        countryId: 470,
        chineseName: '塞尔维亚',
        englishName: 'Serbia',
        twoLetterCode: 'RS',
        phoneCode: '+381',
      },
      {
        countryId: 488,
        chineseName: '圣马力诺',
        englishName: 'San Marino',
        twoLetterCode: 'SM',
        phoneCode: '+378',
      },
      {
        countryId: 454,
        chineseName: '斯洛伐克',
        englishName: 'Slovakia',
        twoLetterCode: 'SK',
        phoneCode: '+421',
      },
      {
        countryId: 476,
        chineseName: '斯洛文尼亚',
        englishName: 'Slovenia',
        twoLetterCode: 'SI',
        phoneCode: '+386',
      },
      {
        countryId: 456,
        chineseName: '匈牙利',
        englishName: 'Hungary',
        twoLetterCode: 'HU',
        phoneCode: '+36',
      },
      {
        countryId: 552,
        chineseName: '泽西岛',
        englishName: 'Jersey',
        twoLetterCode: 'JE',
      },
      {
        countryId: 498,
        chineseName: '直布罗陀',
        englishName: 'Gibraltar',
        twoLetterCode: 'GI',
        phoneCode: '+350',
      },
    ],
  },
  {
    areaName: '非洲',
    areaEnglishName: 'Africa',
    areaKey: 4,
    countryList: [
      {
        countryId: 208,
        chineseName: '埃及',
        englishName: 'Egypt',
        twoLetterCode: 'EG',
        phoneCode: '+20',
      },
      {
        countryId: 250,
        chineseName: '南非',
        englishName: 'South Africa',
        twoLetterCode: 'ZA',
        phoneCode: '+27',
      },
      {
        countryId: 214,
        chineseName: '阿尔及利亚',
        englishName: 'Algeria',
        twoLetterCode: 'DZ',
        phoneCode: '+213',
      },
      {
        countryId: 230,
        chineseName: '埃塞俄比亚',
        englishName: 'Ethiopia',
        twoLetterCode: 'ET',
        phoneCode: '+251',
      },
      {
        countryId: 254,
        chineseName: '安哥拉',
        englishName: 'Angola',
        twoLetterCode: 'AO',
        phoneCode: '+244',
      },
      {
        countryId: 310,
        chineseName: '贝宁',
        englishName: 'Benin',
        twoLetterCode: 'BJ',
        phoneCode: '+229',
      },
      {
        countryId: 272,
        chineseName: '博茨瓦纳',
        englishName: 'Botswana',
        twoLetterCode: 'BW',
        phoneCode: '+267',
      },
      {
        countryId: 292,
        chineseName: '布基纳法索',
        englishName: 'Burkina Faso',
        twoLetterCode: 'BF',
        phoneCode: '+226',
      },
      {
        countryId: 246,
        chineseName: '布隆迪',
        englishName: 'Burundi',
        twoLetterCode: 'BI',
        phoneCode: '+257',
      },
      {
        countryId: 316,
        chineseName: '赤道几内亚',
        englishName: 'Equatorial Guinea',
        twoLetterCode: 'GQ',
        phoneCode: '+240',
      },
      {
        countryId: 308,
        chineseName: '多哥',
        englishName: 'Togo',
        twoLetterCode: 'TG',
        phoneCode: '+228',
      },
      {
        countryId: 232,
        chineseName: '厄立特里亚',
        englishName: 'Eritrea',
        twoLetterCode: 'ER',
        phoneCode: '+291',
      },
      {
        countryId: 298,
        chineseName: '佛得角',
        englishName: 'Cape Verde',
        twoLetterCode: 'CV',
        phoneCode: '+238',
      },
      {
        countryId: 288,
        chineseName: '冈比亚',
        englishName: 'Gambia',
        twoLetterCode: 'GM',
        phoneCode: '+220',
      },
      {
        countryId: 564,
        chineseName: '刚果民主共和国',
        englishName: 'Democratic Republic of the Congo',
        twoLetterCode: 'CD',
        phoneCode: '+243',
      },
      {
        countryId: 236,
        chineseName: '吉布提',
        englishName: 'Djibouti',
        twoLetterCode: 'DJ',
        phoneCode: '+253',
      },
      {
        countryId: 294,
        chineseName: '几内亚',
        englishName: 'Guinea',
        twoLetterCode: 'GN',
        phoneCode: '+224',
      },
      {
        countryId: 296,
        chineseName: '几内亚比绍',
        englishName: 'Guinea-Bissau',
        twoLetterCode: 'GW',
        phoneCode: '+245',
      },
      {
        countryId: 224,
        chineseName: '加那利群岛',
        englishName: 'Pseudo-Accents',
        twoLetterCode: 'XA',
      },
      {
        countryId: 306,
        chineseName: '加纳',
        englishName: 'Ghana',
        twoLetterCode: 'GH',
        phoneCode: '+233',
      },
      {
        countryId: 318,
        chineseName: '加蓬',
        englishName: 'Gabon',
        twoLetterCode: 'GA',
        phoneCode: '+241',
      },
      {
        countryId: 256,
        chineseName: '津巴布韦',
        englishName: 'Zimbabwe',
        twoLetterCode: 'ZW',
        phoneCode: '+263',
      },
      {
        countryId: 314,
        chineseName: '喀麦隆',
        englishName: 'Cameroon',
        twoLetterCode: 'CM',
        phoneCode: '+237',
      },
      {
        countryId: 264,
        chineseName: '科摩罗',
        englishName: 'Comoros',
        twoLetterCode: 'KM',
        phoneCode: '+269',
      },
      {
        countryId: 304,
        chineseName: '科特迪瓦',
        englishName: 'Côte d’Ivoire',
        twoLetterCode: 'CI',
        phoneCode: '+225',
      },
      {
        countryId: 238,
        chineseName: '肯尼亚',
        englishName: 'Kenya',
        twoLetterCode: 'KE',
        phoneCode: '+254',
      },
      {
        countryId: 274,
        chineseName: '莱索托',
        englishName: 'Lesotho',
        twoLetterCode: 'LS',
        phoneCode: '+266',
      },
      {
        countryId: 302,
        chineseName: '利比里亚',
        englishName: 'Liberia',
        twoLetterCode: 'LR',
        phoneCode: '+231',
      },
      {
        countryId: 210,
        chineseName: '利比亚',
        englishName: 'Libya',
        twoLetterCode: 'LY',
        phoneCode: '+218',
      },
      {
        countryId: 276,
        chineseName: '留尼汪',
        englishName: 'Réunion',
        twoLetterCode: 'RE',
        phoneCode: '+262',
      },
      {
        countryId: 244,
        chineseName: '卢旺达',
        englishName: 'Rwanda',
        twoLetterCode: 'RW',
        phoneCode: '+250',
      },
      {
        countryId: 260,
        chineseName: '马达加斯加',
        englishName: 'Madagascar',
        twoLetterCode: 'MG',
        phoneCode: '+261',
      },
      {
        countryId: 218,
        chineseName: '马德拉',
        englishName: 'Madeira',
        twoLetterCode: 'XI',
      },
      {
        countryId: 268,
        chineseName: '马拉维',
        englishName: 'Malawi',
        twoLetterCode: 'MW',
        phoneCode: '+265',
      },
      {
        countryId: 290,
        chineseName: '马里',
        englishName: 'Mali',
        twoLetterCode: 'ML',
        phoneCode: '+223',
      },
      {
        countryId: 258,
        chineseName: '毛里求斯',
        englishName: 'Mauritius',
        twoLetterCode: 'MU',
        phoneCode: '+230',
      },
      {
        countryId: 284,
        chineseName: '毛利塔尼亚',
        englishName: 'Mauritania',
        twoLetterCode: 'MR',
      },
      {
        countryId: 216,
        chineseName: '摩洛哥',
        englishName: 'Morocco',
        twoLetterCode: 'MA',
        phoneCode: '+212',
      },
      {
        countryId: 270,
        chineseName: '莫桑比克',
        englishName: 'Mozambique',
        twoLetterCode: 'MZ',
        phoneCode: '+258',
      },
      {
        countryId: 266,
        chineseName: '纳米比亚',
        englishName: 'Namibia',
        twoLetterCode: 'NA',
        phoneCode: '+264',
      },
      {
        countryId: 228,
        chineseName: '南苏丹',
        englishName: 'South Sudan',
        twoLetterCode: 'SS',
      },
      {
        countryId: 282,
        chineseName: '尼日尔',
        englishName: 'Niger',
        twoLetterCode: 'NE',
        phoneCode: '+227',
      },
      {
        countryId: 280,
        chineseName: '尼日利亚',
        englishName: 'Nigeria',
        twoLetterCode: 'NG',
        phoneCode: '+234',
      },
      {
        countryId: 300,
        chineseName: '塞拉利昂',
        englishName: 'Sierra Leone',
        twoLetterCode: 'SL',
        phoneCode: '+232',
      },
      {
        countryId: 286,
        chineseName: '塞内加尔',
        englishName: 'Senegal',
        twoLetterCode: 'SN',
        phoneCode: '+221',
      },
      {
        countryId: 248,
        chineseName: '塞舌尔',
        englishName: 'Seychelles',
        twoLetterCode: 'SC',
        phoneCode: '+248',
      },
      {
        countryId: 320,
        chineseName: '圣多美和普林西比',
        englishName: 'São Tomé & Príncipe',
        twoLetterCode: 'ST',
        phoneCode: '+239',
      },
      {
        countryId: 278,
        chineseName: '圣赫勒拿',
        englishName: 'St. Helena',
        twoLetterCode: 'SH',
        phoneCode: '+290',
      },
      {
        countryId: 262,
        chineseName: '斯威士兰',
        englishName: 'Eswatini',
        twoLetterCode: 'SZ',
        phoneCode: '+268',
      },
      {
        countryId: 226,
        chineseName: '苏丹',
        englishName: 'Sudan',
        twoLetterCode: 'SD',
        phoneCode: '+249',
      },
      {
        countryId: 234,
        chineseName: '索马里',
        englishName: 'Somalia',
        twoLetterCode: 'SO',
        phoneCode: '+252',
      },
      {
        countryId: 240,
        chineseName: '坦桑尼亚',
        englishName: 'Tanzania',
        twoLetterCode: 'TZ',
        phoneCode: '+255',
      },
      {
        countryId: 212,
        chineseName: '突尼斯',
        englishName: 'Tunisia',
        twoLetterCode: 'TN',
        phoneCode: '+216',
      },
      {
        countryId: 242,
        chineseName: '乌干达',
        englishName: 'Uganda',
        twoLetterCode: 'UG',
        phoneCode: '+256',
      },
      {
        countryId: 222,
        chineseName: '西撒哈拉',
        englishName: 'Western Sahara',
        twoLetterCode: 'EH',
      },
      {
        countryId: 220,
        chineseName: '亚速尔',
        englishName: 'Azores',
        twoLetterCode: 'XH',
      },
      {
        countryId: 252,
        chineseName: '赞比亚',
        englishName: 'Zambia',
        twoLetterCode: 'ZM',
        phoneCode: '+260',
      },
      {
        countryId: 312,
        chineseName: '乍得',
        englishName: 'Chad',
        twoLetterCode: 'TD',
        phoneCode: '+235',
      },
    ],
  },
  {
    areaName: '中东',
    areaEnglishName: 'The Middle East',
    areaKey: 5,
    countryList: [
      {
        countryId: 178,
        chineseName: '阿联酋',
        englishName: 'United Arab Emirates',
        twoLetterCode: 'AE',
        phoneCode: '+971',
      },
      {
        countryId: 170,
        chineseName: '沙特阿拉伯',
        englishName: 'Saudi Arabia',
        twoLetterCode: 'SA',
        phoneCode: '+966',
      },
      {
        countryId: 186,
        chineseName: '土耳其',
        englishName: 'Turkey',
        twoLetterCode: 'TR',
        phoneCode: '+90',
      },
      {
        countryId: 172,
        chineseName: '伊朗',
        englishName: 'Iran',
        twoLetterCode: 'IR',
        phoneCode: '+98',
      },
      {
        countryId: 188,
        chineseName: '以色列',
        englishName: 'Israel',
        twoLetterCode: 'IL',
        phoneCode: '+972',
      },
      {
        countryId: 562,
        chineseName: '阿富汗',
        englishName: 'Afghanistan',
        twoLetterCode: 'AF',
        phoneCode: '+93',
      },
      {
        countryId: 180,
        chineseName: '阿曼',
        englishName: 'Oman',
        twoLetterCode: 'OM',
        phoneCode: '+968',
      },
      {
        countryId: 206,
        chineseName: '阿塞拜疆',
        englishName: 'Azerbaijan',
        twoLetterCode: 'AZ',
        phoneCode: '+994',
      },
      {
        countryId: 190,
        chineseName: '巴勒斯坦',
        englishName: 'Palestinian Territories',
        twoLetterCode: 'PS',
        phoneCode: '+970',
      },
      {
        countryId: 184,
        chineseName: '巴林',
        englishName: 'Bahrain',
        twoLetterCode: 'BH',
        phoneCode: '+973',
      },
      {
        countryId: 202,
        chineseName: '格鲁吉亚',
        englishName: 'Georgia',
        twoLetterCode: 'GE',
        phoneCode: '+995',
      },
      {
        countryId: 182,
        chineseName: '卡塔尔',
        englishName: 'Qatar',
        twoLetterCode: 'QA',
        phoneCode: '+974',
      },
      {
        countryId: 176,
        chineseName: '科威特',
        englishName: 'Kuwait',
        twoLetterCode: 'KW',
        phoneCode: '+965',
      },
      {
        countryId: 194,
        chineseName: '黎巴嫩',
        englishName: 'Lebanon',
        twoLetterCode: 'LB',
        phoneCode: '+961',
      },
      {
        countryId: 200,
        chineseName: '塞浦路斯',
        englishName: 'Cyprus',
        twoLetterCode: 'CY',
        phoneCode: '+357',
      },
      {
        countryId: 192,
        chineseName: '叙利亚',
        englishName: 'Syria',
        twoLetterCode: 'SY',
        phoneCode: '+963',
      },
      {
        countryId: 204,
        chineseName: '亚美尼亚',
        englishName: 'Armenia',
        twoLetterCode: 'AM',
        phoneCode: '+374',
      },
      {
        countryId: 198,
        chineseName: '也门',
        englishName: 'Yemen',
        twoLetterCode: 'YE',
        phoneCode: '+967',
      },
      {
        countryId: 174,
        chineseName: '伊拉克',
        englishName: 'Iraq',
        twoLetterCode: 'IQ',
        phoneCode: '+964',
      },
      {
        countryId: 196,
        chineseName: '约旦',
        englishName: 'Jordan',
        twoLetterCode: 'JO',
        phoneCode: '+962',
      },
    ],
  },
  {
    areaName: '东亚',
    areaEnglishName: 'East Asia',
    areaKey: 6,
    countryList: [
      {
        countryId: 122,
        chineseName: '韩国',
        englishName: 'South Korea',
        twoLetterCode: 'KR',
        phoneCode: '+82',
      },
      {
        countryId: 124,
        chineseName: '日本',
        englishName: 'Japan',
        twoLetterCode: 'JP',
        phoneCode: '+81',
      },
      {
        countryId: 132,
        chineseName: '中国',
        englishName: 'China',
        twoLetterCode: 'CN',
        phoneCode: '+86',
      },
      {
        countryId: 130,
        chineseName: '中国澳门',
        englishName: 'Macao SAR China',
        twoLetterCode: 'MO',
        phoneCode: '+853',
      },
      {
        countryId: 126,
        chineseName: '中国台湾',
        englishName: 'Taiwan(China)',
        twoLetterCode: 'TW',
        phoneCode: '+886',
      },
      {
        countryId: 128,
        chineseName: '中国香港',
        englishName: 'Hong Kong SAR China',
        twoLetterCode: 'HK',
        phoneCode: '+852',
      },
      {
        countryId: 136,
        chineseName: '朝鲜',
        englishName: 'North Korea',
        twoLetterCode: 'KP',
        phoneCode: '+850',
      },
      {
        countryId: 134,
        chineseName: '蒙古',
        englishName: 'Mongolia',
        twoLetterCode: 'MN',
        phoneCode: '+976',
      },
    ],
  },
  {
    areaName: '南亚',
    areaEnglishName: 'South Asia',
    areaKey: 7,
    countryList: [
      {
        countryId: 138,
        chineseName: '印度',
        englishName: 'India',
        twoLetterCode: 'IN',
        phoneCode: '+91',
      },
      {
        countryId: 140,
        chineseName: '巴基斯坦',
        englishName: 'Pakistan',
        twoLetterCode: 'PK',
        phoneCode: '+92',
      },
      {
        countryId: 150,
        chineseName: '不丹',
        englishName: 'Bhutan',
        twoLetterCode: 'BT',
        phoneCode: '+975',
      },
      {
        countryId: 148,
        chineseName: '马尔代夫',
        englishName: 'Maldives',
        twoLetterCode: 'MV',
        phoneCode: '+960',
      },
      {
        countryId: 142,
        chineseName: '孟加拉国',
        englishName: 'Bangladesh',
        twoLetterCode: 'BD',
        phoneCode: '+880',
      },
      {
        countryId: 144,
        chineseName: '尼泊尔',
        englishName: 'Nepal',
        twoLetterCode: 'NP',
        phoneCode: '+977',
      },
      {
        countryId: 146,
        chineseName: '斯里兰卡',
        englishName: 'Sri Lanka',
        twoLetterCode: 'LK',
        phoneCode: '+94',
      },
    ],
  },
  {
    areaName: '北美',
    areaEnglishName: 'North America',
    areaKey: 8,
    countryList: [
      {
        countryId: 324,
        chineseName: '加拿大',
        englishName: 'Canada',
        twoLetterCode: 'CA',
        phoneCode: '+1',
      },
      {
        countryId: 322,
        chineseName: '美国',
        englishName: 'United States',
        twoLetterCode: 'US',
        phoneCode: '+1',
      },
      {
        countryId: 326,
        chineseName: '墨西哥',
        englishName: 'Mexico',
        twoLetterCode: 'MX',
        phoneCode: '+52',
      },
      {
        countryId: 328,
        chineseName: '格陵兰',
        englishName: 'Greenland',
        twoLetterCode: 'GL',
        phoneCode: '+299',
      },
      {
        countryId: 558,
        chineseName: '荷属安的列斯',
        englishName: 'Netherlands Antilles',
        twoLetterCode: 'AN',
        phoneCode: '+599',
      },
      {
        countryId: 330,
        chineseName: '圣皮埃尔和密克隆',
        englishName: 'St. Pierre & Miquelon',
        twoLetterCode: 'PM',
        phoneCode: '+508',
      },
    ],
  },
  {
    areaName: '南美',
    areaEnglishName: 'South America',
    areaKey: 9,
    countryList: [
      {
        countryId: 336,
        chineseName: '阿根廷',
        englishName: 'Argentina',
        twoLetterCode: 'AR',
        phoneCode: '+54',
      },
      {
        countryId: 332,
        chineseName: '巴西',
        englishName: 'Brazil',
        twoLetterCode: 'BR',
        phoneCode: '+55',
      },
      {
        countryId: 334,
        chineseName: '哥伦比亚',
        englishName: 'Colombia',
        twoLetterCode: 'CO',
        phoneCode: '+57',
      },
      {
        countryId: 398,
        chineseName: '阿鲁巴',
        englishName: 'Aruba',
        twoLetterCode: 'AW',
        phoneCode: '+297',
      },
      {
        countryId: 390,
        chineseName: '安圭拉',
        englishName: 'Anguilla',
        twoLetterCode: 'AI',
        phoneCode: '+1264',
      },
      {
        countryId: 370,
        chineseName: '安提瓜和巴布达',
        englishName: 'Antigua & Barbuda',
        twoLetterCode: 'AG',
        phoneCode: '+1268',
      },
      {
        countryId: 382,
        chineseName: '巴巴多斯',
        englishName: 'Barbados',
        twoLetterCode: 'BB',
        phoneCode: '+1246',
      },
      {
        countryId: 348,
        chineseName: '巴哈马',
        englishName: 'Bahamas',
        twoLetterCode: 'BS',
        phoneCode: '+1242',
      },
      {
        countryId: 352,
        chineseName: '巴拉圭',
        englishName: 'Paraguay',
        twoLetterCode: 'PY',
        phoneCode: '+595',
      },
      {
        countryId: 344,
        chineseName: '巴拿马',
        englishName: 'Panama',
        twoLetterCode: 'PA',
        phoneCode: '+507',
      },
      {
        countryId: 408,
        chineseName: '百慕大',
        englishName: 'Bermuda',
        twoLetterCode: 'BM',
        phoneCode: '+1441',
      },
      {
        countryId: 386,
        chineseName: '波多黎各',
        englishName: 'Puerto Rico',
        twoLetterCode: 'PR',
        phoneCode: '+1809',
      },
      {
        countryId: 360,
        chineseName: '玻利维亚',
        englishName: 'Bolivia',
        twoLetterCode: 'BO',
        phoneCode: '+591',
      },
      {
        countryId: 412,
        chineseName: '伯利兹',
        englishName: 'Belize',
        twoLetterCode: 'BZ',
        phoneCode: '+501',
      },
      {
        countryId: 368,
        chineseName: '多米尼加',
        englishName: 'Dominican Republic',
        twoLetterCode: 'DO',
        phoneCode: '+1809',
      },
      {
        countryId: 374,
        chineseName: '多米尼克',
        englishName: 'Dominica',
        twoLetterCode: 'DM',
        phoneCode: '+1767',
      },
      {
        countryId: 354,
        chineseName: '厄瓜多尔',
        englishName: 'Ecuador',
        twoLetterCode: 'EC',
        phoneCode: '+593',
      },
      {
        countryId: 410,
        chineseName: '法属圣马丁',
        englishName: 'St. Martin',
        twoLetterCode: 'MF',
      },
      {
        countryId: 364,
        chineseName: '哥斯达黎加',
        englishName: 'Costa Rica',
        twoLetterCode: 'CR',
        phoneCode: '+506',
      },
      {
        countryId: 380,
        chineseName: '格林纳达',
        englishName: 'Grenada',
        twoLetterCode: 'GD',
        phoneCode: '+1473',
      },
      {
        countryId: 346,
        chineseName: '古巴',
        englishName: 'Cuba',
        twoLetterCode: 'CU',
        phoneCode: '+53',
      },
      {
        countryId: 394,
        chineseName: '瓜德罗普',
        englishName: 'Guadeloupe',
        twoLetterCode: 'GP',
        phoneCode: '+590',
      },
      {
        countryId: 560,
        chineseName: '圭亚那',
        englishName: 'Guyana',
        twoLetterCode: 'GY',
        phoneCode: '+592',
      },
      {
        countryId: 366,
        chineseName: '海地',
        englishName: 'Haiti',
        twoLetterCode: 'HT',
        phoneCode: '+509',
      },
      {
        countryId: 402,
        chineseName: '荷属圣马丁',
        englishName: 'Sint Maarten',
        twoLetterCode: 'SX',
      },
      {
        countryId: 416,
        chineseName: '洪都拉斯',
        englishName: 'Honduras',
        twoLetterCode: 'HN',
        phoneCode: '+504',
      },
      {
        countryId: 406,
        chineseName: '开曼群岛',
        englishName: 'Cayman Islands',
        twoLetterCode: 'KY',
        phoneCode: '+1345',
      },
      {
        countryId: 400,
        chineseName: '库拉索',
        englishName: 'Curaçao',
        twoLetterCode: 'CW',
      },
      {
        countryId: 396,
        chineseName: '马提尼克',
        englishName: 'Martinique',
        twoLetterCode: 'MQ',
        phoneCode: '+596',
      },
      {
        countryId: 392,
        chineseName: '蒙特塞拉特',
        englishName: 'Montserrat',
        twoLetterCode: 'MS',
        phoneCode: '+1664',
      },
      {
        countryId: 338,
        chineseName: '秘鲁',
        englishName: 'Peru',
        twoLetterCode: 'PE',
        phoneCode: '+51',
      },
      {
        countryId: 362,
        chineseName: '尼加拉瓜',
        englishName: 'Nicaragua',
        twoLetterCode: 'NI',
        phoneCode: '+505',
      },
      {
        countryId: 414,
        chineseName: '萨尔瓦多',
        englishName: 'El Salvador',
        twoLetterCode: 'SV',
        phoneCode: '+503',
      },
      {
        countryId: 372,
        chineseName: '圣基茨和尼维斯',
        englishName: 'St. Kitts & Nevis',
        twoLetterCode: 'KN',
        phoneCode: '+1869',
      },
      {
        countryId: 376,
        chineseName: '圣卢西亚',
        englishName: 'St. Lucia',
        twoLetterCode: 'LC',
        phoneCode: '+1758',
      },
      {
        countryId: 378,
        chineseName: '圣文森特和格林纳丁斯',
        englishName: 'St. Vincent & Grenadines',
        twoLetterCode: 'VC',
        phoneCode: '+1784',
      },
      {
        countryId: 404,
        chineseName: '特克斯和凯科斯群岛',
        englishName: 'Turks & Caicos Islands',
        twoLetterCode: 'TC',
        phoneCode: '+1649',
      },
      {
        countryId: 384,
        chineseName: '特立尼达和多巴哥',
        englishName: 'Trinidad & Tobago',
        twoLetterCode: 'TT',
        phoneCode: '+1868',
      },
      {
        countryId: 358,
        chineseName: '危地马拉',
        englishName: 'Guatemala',
        twoLetterCode: 'GT',
        phoneCode: '+502',
      },
      {
        countryId: 356,
        chineseName: '委内瑞拉',
        englishName: 'Venezuela',
        twoLetterCode: 'VE',
        phoneCode: '+58',
      },
      {
        countryId: 350,
        chineseName: '乌拉圭',
        englishName: 'Uruguay',
        twoLetterCode: 'UY',
        phoneCode: '+598',
      },
      {
        countryId: 342,
        chineseName: '牙买加',
        englishName: 'Jamaica',
        twoLetterCode: 'JM',
        phoneCode: '+1876',
      },
      {
        countryId: 388,
        chineseName: '英属维尔京群岛',
        englishName: 'British Virgin Islands',
        twoLetterCode: 'VG',
        phoneCode: '+1284',
      },
      {
        countryId: 340,
        chineseName: '智利',
        englishName: 'Chile',
        twoLetterCode: 'CL',
        phoneCode: '+56',
      },
    ],
  },
];

const getCountryCode2ChineseNameMap = () => {
  const res: Record<string, string> = {};

  areaCountryList.forEach((a) => {
    a.countryList.forEach((c) => {
      res[c.twoLetterCode] = c.chineseName;
    });
  });

  return res;
};

const getCountryCode2EnglishNameMap = () => {
  const res: Record<string, string> = {};

  areaCountryList.forEach((a) => {
    a.countryList.forEach((c) => {
      res[c.twoLetterCode] = c.englishName;
    });
  });

  return res;
};
export const countryCode2ChineseNameMap = getCountryCode2ChineseNameMap();

export const countryCode2EnglishNameMap = getCountryCode2EnglishNameMap();
